import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/5rtHZUgQD2bv2iapiJEGC2/Mockup.png';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-63" data-mp="4lqictyan92g">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-64" data-mp="129h2fs8fj8fj" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-65" data-mp="1274n7mu23c66">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-[-10px] mt-[-45px] font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl" data-id="element-66" data-mp="xaxg3qpxbumn">
          🌿BIOMA LÍVIDO™
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mx-auto mt-5 max-w-5xl font-display text-[19px] font-bold text-white sm:text-5xl lg:text-6xl" data-id="element-67" data-mp="382fi9x3dfkj5">
          Desinflamá tu panza en 21 días{' '}
          <span className="text-brand-light" data-id="element-68" data-mp="3e9625rf943h1">
            ordenando qué comés, cuándo lo comés y en qué orden lo reintroducís.
          </span>
        </motion.h1>
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-69" data-mp="30gq1gx9tohja">
          <img src={mockupUrl} alt="Mockup del Protocolo Rescate SIBO" width="1200" height="1200" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl" data-id="element-70" data-mp="2vglmxcsh5wvp" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35
      }} className="mx-auto max-w-2xl" data-id="element-71" data-mp="nbbe31x26h6v">
          <p className="mb-[-8px] font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl" data-id="element-72" data-mp="dbar95zzdixx">
            PROTOCOLO — RESCATE SIBO™
          </p>
          <p className="mb-[-19px] mt-3 text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-73" data-mp="162c9jfyyzulo">
            El primer sistema práctico para quienes ya probaron de todo y
            siguen hinchándose después de comer, aunque los estudios “den
            bien”.
          </p>
          <div className="mb-[-21px] mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" data-id="element-74" data-mp="3lt74enpyzlso">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-75" data-mp="3hpsf16g55t2k">
              <FileTextIcon className="h-4 w-4 text-brand-light" data-id="element-76" data-mp="1x7869rdijxvp" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-77" data-mp="218jubsgqob1s">
              <ZapIcon className="h-4 w-4 text-brand-gold" data-id="element-78" data-mp="2b0fz1mdbyzez" />
              Acceso en 5 min
            </span>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.45
      }} className="mx-auto mt-7 max-w-lg" data-id="element-79" data-mp="2fzamx2q5ne5y">
          <ActionButton href="#pricing" showTrust data-id="element-80" data-mp="2tz1ykwt78igs">
            QUIERO MI SISTEMA AHORA
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}